module.exports = __webpack_public_path__ + "fonts/VetoSans-Light_2.7c14e379.woff";